export enum SeriesType {
  all = 'ALL',
  energy = 'Energy',
  pcs = 'PCS',
  volume = 'Volume',
  voltage = 'voltage',
  zNumber = 'z_number',
  downtime = 'downtime',
  activePower = 'active_power',
  capacitiveReactivePower = 'capacitive_reactive_power',
  inductiveReactivePower = 'inductive_reactive_power',
  consumptionWithCarbonAccounting = 'consumptionWithCarbonAccounting',
  consumptionWithNominationClient = 'consumptionWithNominationClient',
  consumptionWithNominationEnige = 'consumptionWithNominationEnige',
}
